import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Button} from 'reactstrap';
import Dialog from '../../apa/containers/Dialog';
import autobind from 'autobind-decorator';

@connect(
    state => (
        {
            auth: state.apa
        }
    )
)
export default class DeleteReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }

    @autobind
    toggle() {
        this.setState(
            {
                isOpen: !this.state.isOpen
            }
        )
    }

    @autobind
    confirm() {
        this.toggle();
        const report = this.props.report;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.props.auth.token}`
        };
        fetch(
            `/api/reports/${report.id}/`,
            {headers, method: 'DELETE'}
        ).then(
            () => {
                this.props.callback()
            }
        )
    }

    render() {
        return (
            <Fragment>
                <Button color='danger' onClick={this.toggle}>
                    <i className={'fa fa-trash'}> </i>
                </Button>
                <Dialog
                    isOpen={this.state.isOpen}
                    toggle={this.toggle}
                    confirm={this.confirm}
                    title={'Bericht löschen'}
                >
                    Sind Sie sicher?
                </Dialog>
            </Fragment>
        )
    }

}